/* global document */
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { PersistGate } from 'redux-persist/integration/react';
import App from 'components/App';
import GlobalStyles from './theme/globalStyles';
import store, { persistor } from './store';
import theme from './theme';

const Root: React.FC = (): JSX.Element => (
  <ThemeProvider theme={theme}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
        <GlobalStyles />
      </PersistGate>
    </Provider>
  </ThemeProvider>
);

ReactDOM.render(<Root />, document.getElementById('root'));
